<div class="ppl-container-body">
    <div class="ppl-container-head">
        Config
    </div>
    <div class="ppl-container">
        <div class="ppl-content-container"
            style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">

            <div style="width: 100%; box-sizing: border-box;">
                <div class="ppl-tabs">
                    <!-- <div class="ppl-nav ppl-nav-tabs">
                        @for (menuItem of horizontalMenuItemstoDisplay; track $index) {
                        <div class="ppl-nav-item">
                            <a class="ppl-nav-link"
                                [ngClass]="{'single-tab': horizontalMenuItemstoDisplay.length === 1}"
                                [class.active]="menuItem.menu_id === selectedMenuItem"
                                (click)="onMenuSelection(menuItem)" href="javascript:void(0)">
                                {{ menuItem.menu_label }}
                            </a>
                        </div>
                        }
                    </div> -->
                    <div class="ppl-nav ppl-nav-tabs collapse d-md-flex">
                        <div *ngFor="let section of sections;" class="ppl-nav-item">
                            <a class="ppl-nav-link" (click)="onSectionSelection(section)" [class.active]="section === selectedSection"
                                href="javascript:void(0)">
                                {{ section }}
                            </a>
                        </div>
                    </div>
                    <div class="tab-content">
                        @if(showAppConfig) {
                            <ppl-config-list></ppl-config-list>

                        } @else {
                            <ppl-lookup-config-list></ppl-lookup-config-list>
                        }
                      </div>
                </div>
            </div>
        </div>
    </div>
</div>
